module.exports = __webpack_public_path__ + "img/icn-slot.c028f03a.png";